import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Contexts from "../../contexts/Contexts";
import styles from "./index.module.css";

const SHOW_ON_PATHS = ["/", "/groups"];
const SCROLL_THRESHOLD = 200;

const CriarContaBar = () => {
  const { userId, isDrawerOpen, setIsRegistrationOpen } = useContext(Contexts);
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const isAllowedPath = SHOW_ON_PATHS.includes(pathname);

  useEffect(() => {
    if (!isAllowedPath || userId) {
      setVisible(false);
      return;
    }

    const handleScroll = () => {
      setVisible(window.scrollY >= SCROLL_THRESHOLD);
    };

    // Check immediately (in case page is pre-scrolled)
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isAllowedPath, userId, pathname]);

  if (!isAllowedPath || userId || isDrawerOpen) return null;

  return (
    <div className={`${styles.bar} ${visible ? styles.visible : ""}`}>
      <div className={styles.inner}>
        <span className={styles.text}>Explore os melhores sorteios do Brasil</span>
        <button
          className={styles.cta}
          onClick={() => setIsRegistrationOpen(true)}
        >
          {t("auth.createAccount")} Grátis
        </button>
      </div>
    </div>
  );
};

export default CriarContaBar;
